module.exports = __webpack_public_path__ + "img/Unidad17-4.8abe274a.png";